var tableTitle = document.querySelectorAll('.qrtable__title')

tableTitle.forEach(function (el) {
    el.addEventListener('click', function (e) {
        var tableBody = this.nextElementSibling

        this.classList.toggle('qrtable__title--active')
        tableBody.classList.toggle('qrtable--show')
    })
})